import { Injectable } from "@angular/core";
import {HttpClient} from '@angular/common/http';

import {FilterParams} from "app/models/filter_form.model";
import {BaseService} from "app/views/base.service";
import { MailerReportStatus } from "app/models/mail";
import { DataProvider2, DataProviderFactory, DataRequest } from "../provider/data2.provider";

@Injectable()
export class MailService extends BaseService {
	public mail: DataRequest;
	public mailStatus: DataRequest;
	public mailer: DataRequest;
	public testMail: DataRequest;
	
	constructor(
		public http: HttpClient,
		public dpf: DataProviderFactory,
		public dp2: DataProvider2,
	) {
		super(http);

		this.mail = this.dpf.getNew('mail');
		this.mailStatus = this.dpf.getNew('mail_status');
		this.mailer = this.dpf.getNew('mailer');
		this.testMail = this.dpf.getNew('mails/test');
	}
	
	getMailerReportList() {
		return this.dp2.get('/mailer/report');
	}
	
	
	/**
	 * 
	 * @param fp {FilterParams} Фильтры выборки
	 * @param params {Object} Параметры выборки (поля, типы емейлов и т.п.)
	 */
	addMailerNewReport(reportName, fp: FilterParams, params: any) {
		return this.dp2.post('/mailer/report', {
			...fp,
			report: {
				reportName,
				...params
			}
		});
	}
	
	
	removeMailerReport(reportId: number) {
		return this.dp2.delete('/mailer/report', { reportId });
	}
	
	
	sendToMailer(report, deliveryId) {
		return this.dp2.post('/mailer', { deliveryId, ...report});
	}


	sendTestMail(data) {
		return this.dp2.post('/api/mail/sendtest', data);
	}
	
	
	updateReportStatus(reportId, status: MailerReportStatus) {
		return this.dp2.put('/mailer/report', { reportId, status });
	}
}
